import { ConnectionSnippet } from 'modules/chains/components/ConnectionSnippet';
import { useChainSelectors } from 'modules/chains/components/ChainSelectorsProvider';
import { ChainGroupID } from 'modules/endpoints/types';

import { CodeSnippetPlaceholder } from '../CodeSnippetPlaceholder';
import { VrpcCodeSnippet } from '../VrpcCodeSnippet';
import { useCodeSnippet } from './hooks/useCodeSnippet';

export const CodeSnippet = () => {
  const { httpCode, isHidden, setTechnology, technology, wssCode } =
    useCodeSnippet();

  const { group, isConsensusEnabled } = useChainSelectors();

  if (group.id === ChainGroupID.VRPC) {
    return <VrpcCodeSnippet />;
  }

  const hasCode = wssCode || httpCode;
  const hasPlaceholder = isConsensusEnabled || isHidden || !hasCode;

  return (
    <ConnectionSnippet
      hasFullWidthSnippets
      httpCode={httpCode}
      isTitleHidden
      placeholder={hasPlaceholder && <CodeSnippetPlaceholder />}
      setTechnology={setTechnology}
      technology={technology}
      wssCode={wssCode}
    />
  );
};
